import React from 'react'
import { Field } from 'redux-form'

const FieldComponent = ({ WrappedComponent, wrappedComponentProps, meta }) => (
  <WrappedComponent formMeta={meta} {...wrappedComponentProps} />
)

const withFormMeta = (WrappedComponent) => (props) => (
  <Field
    name="##see-withFormMeta-HOC"
    component={FieldComponent}
    WrappedComponent={WrappedComponent}
    wrappedComponentProps={props}
  />
)

export default withFormMeta
